'use strict';

async function scanPendingPacks(readPage, {
  isCurrent = () => true,
  maxPages = 200
} = {}) {
  let cursor;
  const seen = new Set();

  for (let page = 0; page < maxPages; page++) {
    if (!isCurrent()) throw Error('SESSION_CHANGED');
    const value = await readPage(cursor);
    if (!isCurrent()) throw Error('SESSION_CHANGED');
    if (!value || !Array.isArray(value.items) || value.items.length > 50 || !(value.cursor === null || typeof value.cursor === 'string' && value.cursor.length > 0 && value.cursor.length <= 1024) || value.items.some(p => !p || !['SEALED', 'REVEALED', 'OPENED'].includes(p.status))) throw Error('INVALID_PACK_LIST');
    if (value.items.some(p => p.status === 'SEALED' || p.status === 'REVEALED')) return {
      known: true,
      pending: true
    };
    if (value.cursor === null) return {
      known: true,
      pending: false
    };
    if (seen.has(value.cursor)) throw Error('REPEATED_PACK_CURSOR');
    seen.add(value.cursor);
    cursor = value.cursor;
  }

  throw Error('PACK_SCAN_INCOMPLETE');
}

function createPendingPackMonitor({
  readPage,
  onChange,
  setTimer = setTimeout,
  clearTimer = clearTimeout,
  pollMs = 60000
}) {
  let disposed = false,
      pending = null,
      timer = null;

  async function refresh() {
    if (disposed) return null;
    if (pending) return pending;
    if (timer !== null) clearTimer(timer);
    timer = null;

    pending = (async () => {
      try {
        const value = await scanPendingPacks(readPage, {
          isCurrent: () => !disposed
        });
        if (!disposed) onChange(value);
        return value;
      } catch (error) {
        if (!disposed) onChange({
          known: false,
          pending: false
        });
        throw error;
      } finally {
        if (!disposed) {
          pending = null;
          timer = setTimer(() => refresh().catch(() => {}), pollMs);
        }
      }
    })();

    return pending;
  }

  return Object.freeze({
    refresh,

    dispose() {
      disposed = true;
      pending = null;
      if (timer !== null) clearTimer(timer);
      timer = null;
    }

  });
}

module.exports = {
  scanPendingPacks,
  createPendingPackMonitor
};
